import { userService } from "../services/userService";
import { useAsyncData } from "./useAsyncData";

export function useUsers(search = "") {
  return useAsyncData(() => userService.listUsers(search), [search]);
}
